import { render, staticRenderFns } from "./NavChat.vue?vue&type=template&id=c3638d18&scoped=true&"
import script from "./NavChat.vue?vue&type=script&scoped=true&lang=js&"
export * from "./NavChat.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./NavChat.vue?vue&type=style&index=0&id=c3638d18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3638d18",
  null
  
)

export default component.exports